


export enum DataImportType {

  BusinessVerificationList = 'business-verification-list',
  Users = "users"

}